import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import CampaignDto from '@/models/Campaigns/CampaignDto';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import FilterCampaignSearchViewModel from '@/models/Campaigns/FilterCampaignSearchViewModel';
import CurrentCampaignSearchCriteria from '@/models/Campaigns/CurrentCampaignSearchCriteria';
import SearchCampaignsRequest from '@/models/Campaigns/SearchCampaignsRequest';
import CreateCampaignRequest from '@/models/Campaigns/CreateCampaignRequest';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';

export interface ICampaignListState {
  loading: boolean;
  campaigns: CampaignDto[];
  filterCampaignSearchViewModel: FilterCampaignSearchViewModel;
  currentCampaignSearchCriteria: CurrentCampaignSearchCriteria;
  newCampaignId: string;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'CampaignList', namespaced: true})
class CampaignList extends VuexModule implements ICampaignListState {
  
  public loading = false;
  public campaigns: CampaignDto[] = [];
  public filterCampaignSearchViewModel: FilterCampaignSearchViewModel = new FilterCampaignSearchViewModel();
  public currentCampaignSearchCriteria: CurrentCampaignSearchCriteria = new CurrentCampaignSearchCriteria();
  public newCampaignId = '';
  public loadingDialog = false;

  @Action
  async searchCampaigns() {
    const request = new SearchCampaignsRequest();

    if (this.filterCampaignSearchViewModel.selectedOwner != null) {
      request.ownerId = this.filterCampaignSearchViewModel.selectedOwner.id;
    }

    if (this.filterCampaignSearchViewModel.selectedBranch != null) {
      request.branchId = this.filterCampaignSearchViewModel.selectedBranch.id;
    }

    if (this.filterCampaignSearchViewModel.selectedDesk != null) {
      request.deskId = this.filterCampaignSearchViewModel.selectedDesk.id;
    }

    request.status = [this.filterCampaignSearchViewModel.selectedStatus];

    this.setLoading(true);
    await ajax.post(`/api/v1/agency/campaigns/search`, request)
    .then(response => {
      this.context.commit("setCampaigns", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async fetchCampaignsByStatuses(statuses: CampaignStatus[]) {
    const request = new SearchCampaignsRequest();
    request.status = statuses;

    this.setLoading(true);
    await ajax.post(`/api/v1/agency/campaigns/search`, request)
      .then(response => {
        this.context.commit("setCampaigns", response.data);
        this.setLoading(false);
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoading(false);
      });
  }

  @Action
  public async createCampaign(request: CreateCampaignRequest) {
    this.setLoading(true); 
    await ajax.post(`/api/v1/agency/campaigns`, request)
    .then(response => {
      this.context.commit("setCampaignIdFromCreate", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
	  this.setLoading(false);
    })
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.campaigns = [];
    this.newCampaignId = '';
    this.filterCampaignSearchViewModel = new FilterCampaignSearchViewModel();
    this.currentCampaignSearchCriteria = new CurrentCampaignSearchCriteria();
    this.loading = false;
    this.loadingDialog = false;
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }

  @Mutation
  private async setCampaigns(campaigns: CampaignDto[]) {
          // Update the latest search criteria 
    this.currentCampaignSearchCriteria = new CurrentCampaignSearchCriteria();
    this.currentCampaignSearchCriteria.selectedBranch = this.filterCampaignSearchViewModel.selectedBranch;
    this.currentCampaignSearchCriteria.selectedDesk = this.filterCampaignSearchViewModel.selectedDesk;
    this.currentCampaignSearchCriteria.selectedEmailTemplate = this.filterCampaignSearchViewModel.selectedEmailTemplate;
    this.currentCampaignSearchCriteria.selectedOwner = this.filterCampaignSearchViewModel.selectedOwner;
    this.currentCampaignSearchCriteria.selectedStatus = this.filterCampaignSearchViewModel.selectedStatus;
      this.campaigns = campaigns;
  }

  @Mutation
  private async setCampaignIdFromCreate(campaign: CampaignDto) {
    this.newCampaignId = campaign.id;
  }
}

export const CampaignListModule = getModule(CampaignList)
